import { Box, Button } from "@mui/material";
import { useHistory } from "react-router-dom";

export const SECTION_IDS = {
  QUIENES_SOMOS: "quiensomos",
  CURSOS: "cursos",
  CURSOS1: "cursos1",
  CURSOS2: "cursos2",
  CLIENT: "client",
  LIBRO: "libro",
  CONTACTO: "contactos",
} as const;

const NAV_ITEMS = [
  { id: SECTION_IDS.QUIENES_SOMOS, label: "Nosotros", type: "section" as const },
  { id: "/cursos", label: "Cursos", type: "route" as const },
  { id: SECTION_IDS.CURSOS1, label: "Servicios", type: "section" as const },
  { id: SECTION_IDS.CLIENT, label: "Clientes", type: "section" as const },
  { id: SECTION_IDS.LIBRO, label: "Material", type: "section" as const },
  { id: SECTION_IDS.CONTACTO, label: "Contacto", type: "section" as const },
];

interface MenuItemProps {
  onClose?: () => void;
  variant?: "desktop" | "mobile";
}

export const scrollToSection = (id: string) => {
  const element = document.getElementById(id);
  element?.scrollIntoView({ behavior: "smooth", block: "start" });
};

export const MenuItem = ({ onClose, variant = "desktop" }: MenuItemProps) => {
  const isMobile = variant === "mobile";
  const history = useHistory();

  const handleClick = (id: string, type: "section" | "route") => {
    if (type === "route") {
      history.push(id);
      window.scrollTo({ top: 0 });
    } else if (history.location.pathname !== "/") {
      history.push("/");
      window.setTimeout(() => scrollToSection(id), 80);
    } else {
      scrollToSection(id);
    }
    onClose?.();
  };

  if (isMobile) {
    return (
      <Box component="nav" aria-label="Secciones del sitio">
        {NAV_ITEMS.map((item) => (
          <Button
            key={item.id}
            onClick={() => handleClick(item.id, item.type)}
            fullWidth
            sx={{
              justifyContent: "flex-start",
              color: "text.primary",
              fontWeight: 700,
              fontSize: "1.15rem",
              letterSpacing: "-0.02em",
              px: 0.25,
              py: 1.5,
              minHeight: 52,
              borderRadius: 0,
              borderBottom: "1px solid",
              borderColor: "divider",
              "&:hover": {
                backgroundColor: "transparent",
                color: "primary.main",
              },
            }}
          >
            {item.label}
          </Button>
        ))}
        <Button
          variant="contained"
          color="primary"
          fullWidth
          onClick={() => handleClick("/ticket", "route")}
          sx={{
            mt: 2.5,
            minHeight: 50,
            fontWeight: 800,
            fontSize: "1rem",
            borderRadius: 2,
          }}
        >
          Ticket
        </Button>
      </Box>
    );
  }

  return (
    <Box
      component="nav"
      aria-label="Secciones del sitio"
      sx={{ display: "flex", alignItems: "center" }}
    >
      {NAV_ITEMS.map((item) => (
        <Button
          key={item.id}
          onClick={() => handleClick(item.id, item.type)}
          color="inherit"
          sx={{
            color: "text.primary",
            fontWeight: 600,
            px: 1.25,
            minHeight: 44,
            "&:hover": {
              backgroundColor: "rgba(30, 90, 138, 0.08)",
              color: "primary.main",
            },
          }}
        >
          {item.label}
        </Button>
      ))}
      <Button
        variant="outlined"
        color="primary"
        onClick={() => handleClick("/ticket", "route")}
        sx={{
          ml: 1.25,
          px: 1.75,
          minHeight: 40,
          borderRadius: "999px",
          fontWeight: 800,
        }}
      >
        Ticket
      </Button>
    </Box>
  );
};
